import { render, staticRenderFns } from "./EvaluateMark.vue?vue&type=template&id=1922546d&scoped=true"
import script from "./EvaluateMark.vue?vue&type=script&lang=js"
export * from "./EvaluateMark.vue?vue&type=script&lang=js"
import style0 from "./EvaluateMark.vue?vue&type=style&index=0&id=1922546d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1922546d",
  null
  
)

export default component.exports